import { useRelatedConditionsHeading } from '../../hooks/useRelatedConditionsHeading';
import EditorIncludeObjectsWithNoAssociatedObjectsInput from './EditorIncludeObjectsWithNoAssociatedObjectsInput';
import EditorUIFieldSet from './EditorUIFieldSet';
import EditorUnifiedEventRefinements from './EditorUnifiedEventRefinements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorRelatedConditionsHeading = props => {
  const {
    inputUse,
    logicGroup,
    conditionPath
  } = props;
  const {
    filterFamilyHeading,
    selectInput,
    showUnifiedEventRefinements
  } = useRelatedConditionsHeading(conditionPath, logicGroup, inputUse);
  return /*#__PURE__*/_jsxs(EditorUIFieldSet, {
    legend: filterFamilyHeading,
    children: [selectInput, /*#__PURE__*/_jsx(EditorIncludeObjectsWithNoAssociatedObjectsInput, {
      conditionPath: conditionPath,
      logicGroup: logicGroup
    }), showUnifiedEventRefinements && /*#__PURE__*/_jsx(EditorUnifiedEventRefinements, {
      conditionPath: conditionPath,
      logicGroup: logicGroup,
      inputUse: inputUse
    })]
  });
};
export default EditorRelatedConditionsHeading;